"use strict";
/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var DataType = /* @__PURE__ */ ((DataType2) => {
  DataType2[DataType2["UINT8"] = 0] = "UINT8";
  DataType2[DataType2["INT8"] = 1] = "INT8";
  DataType2[DataType2["UINT16"] = 2] = "UINT16";
  DataType2[DataType2["INT16"] = 3] = "INT16";
  DataType2[DataType2["UINT32"] = 4] = "UINT32";
  DataType2[DataType2["INT32"] = 5] = "INT32";
  DataType2[DataType2["UINT64"] = 6] = "UINT64";
  DataType2[DataType2["FLOAT32"] = 7] = "FLOAT32";
  return DataType2;
})(DataType || {});
export const DATA_TYPE_SIGNED = {
  [0 /* UINT8 */]: false,
  [1 /* INT8 */]: true,
  [2 /* UINT16 */]: false,
  [3 /* INT16 */]: true,
  [4 /* UINT32 */]: false,
  [5 /* INT32 */]: true,
  [6 /* UINT64 */]: false,
  [7 /* FLOAT32 */]: void 0
};
export const DATA_TYPE_BYTES = {
  [0 /* UINT8 */]: 1,
  [1 /* INT8 */]: 1,
  [2 /* UINT16 */]: 2,
  [3 /* INT16 */]: 2,
  [4 /* UINT32 */]: 4,
  [5 /* INT32 */]: 4,
  [6 /* UINT64 */]: 8,
  [7 /* FLOAT32 */]: 4
};
export const DATA_TYPE_ARRAY_CONSTRUCTOR = {
  [0 /* UINT8 */]: Uint8Array,
  [1 /* INT8 */]: Int8Array,
  [2 /* UINT16 */]: Uint16Array,
  [3 /* INT16 */]: Int16Array,
  [4 /* UINT32 */]: Uint32Array,
  [5 /* INT32 */]: Int32Array,
  [6 /* UINT64 */]: Uint32Array,
  [7 /* FLOAT32 */]: Float32Array
};
export const DATA_TYPE_JAVASCRIPT_ELEMENTS_PER_ARRAY_ELEMENT = {
  [0 /* UINT8 */]: 1,
  [1 /* INT8 */]: 1,
  [2 /* UINT16 */]: 1,
  [3 /* INT16 */]: 1,
  [4 /* UINT32 */]: 1,
  [5 /* INT32 */]: 1,
  [6 /* UINT64 */]: 2,
  [7 /* FLOAT32 */]: 1
};
export function makeDataTypeArrayView(dataType, buffer, byteOffset = 0, byteLength = buffer.byteLength) {
  const bytesPerElement = DATA_TYPE_BYTES[dataType];
  const javascriptElementsPerArrayElement = DATA_TYPE_JAVASCRIPT_ELEMENTS_PER_ARRAY_ELEMENT[dataType];
  return new DATA_TYPE_ARRAY_CONSTRUCTOR[dataType](
    buffer,
    byteOffset,
    byteLength / bytesPerElement * javascriptElementsPerArrayElement
  );
}
